export default function CommonSituationsSection() {
  const situations = [
    {
      icon: "ri-calendar-close-line",
      title: "Expired Passport, Trip This Week",
      description: "Your passport expired and you just realized it. This is our most common emergency call. Renewal is possible in as little as 3 business days if you qualify for DS-82. Call now.",
      link: "/passport-services/renewal/",
      linkText: "Passport Renewal",
    },
    {
      icon: "ri-file-search-line",
      title: "Lost or Stolen Passport Before Travel",
      description: "Your passport disappeared before your trip. You need to file DS-64 (lost/stolen report) and apply for a new passport with DS-11. We handle both. Call immediately.",
      link: "/passport-services/lost-stolen/",
      linkText: "Lost/Stolen Passport",
    },
    {
      icon: "ri-briefcase-line",
      title: "Just Got Travel Notification for Work",
      description: "Last-minute international business trip assigned with no notice. You need a passport in days. We've handled thousands of corporate emergency situations. Same-day order processing available.",
      link: "https://fastpassportcenter.com/checkout/",
      linkText: "Start Order",
    },
    {
      icon: "ri-user-heart-line",
      title: "Child Passport Emergency",
      description: "Your child's passport expired or was never applied for, and the family trip is soon. Child passports require both parents and have additional requirements — we guide you through exactly what's needed fast.",
      link: "/passport-services/child-passport/",
      linkText: "Child Passport Info",
    },
    {
      icon: "ri-heart-pulse-line",
      title: "Family Emergency Abroad",
      description: "A family member is critically ill or has passed away abroad and you need to travel immediately. Special documentation applies. Call us directly and we'll handle your case as a priority.",
      link: "tel:8772530084",
      linkText: "Call Now",
    },
    {
      icon: "ri-ship-line",
      title: "Cruise or Tour Departure",
      description: "Your cruise or group tour leaves in days and your passport situation just became clear. We handle pre-departure passport emergencies regularly — call us now so we can assess your timeline.",
      link: "tel:8772530084",
      linkText: "Call Now",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-red-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">Real Situations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common <span className="text-red-600">Passport Emergencies</span> We Handle Every Day
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            These are the situations we see most often. If yours isn't listed, call us — we've likely handled it before.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {situations.map((item, i) => (
            <div key={i} className="bg-white rounded-lg border border-gray-200 p-6 hover:border-red-200 transition-colors">
              <div className="w-11 h-11 rounded-full bg-red-50 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-red-600 text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{item.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{item.description}</p>
              <a
                href={item.link}
                className={`inline-flex items-center gap-1.5 text-sm font-semibold transition-colors whitespace-nowrap ${
                  item.link.startsWith("tel:")
                    ? "text-red-600 hover:text-red-800"
                    : "text-[#1A365D] hover:text-red-600"
                }`}
              >
                {item.linkText} <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-3">Don't see your situation? Call us — we likely have a solution.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}